/* Imports */
import { API_HELPER } from "@/helpers/api.js";
import { authHeader } from "@/helpers/auth-header.js";

/* Exports */
// API services that can be invoked on the modules
export const CATEGORY_SERVICE = {
    getBrand
};

/* Consts*/
// Root service to build API url
const API_ROOT_SERVICE = "categories";

/* Services */
function getBrand(brand, queryParams)
{
    // Build API call.
    var url = API_HELPER.pathJoin([process.env.VUE_APP_API_ROOT, API_ROOT_SERVICE, "brand", brand]);    

    const requestOptions = {
        method: 'GET',
        headers: { ...authHeader() }
    }; 

    // Process API call, validating the token beforehand.
    return API_HELPER.apiCall(url, queryParams, requestOptions);
}



